"use client"

import { useState } from "react"
import Image from "next/image"

const isValidAvatarUrl = (url: string) => /^https?:\/\//.test(url) || url.startsWith("/")

interface AvatarWithFallbackProps {
  src: string | null
  name: string | null
}

// 头像加载失败（URL 非法、404、403 等）时，用蓝色背景 SVG + 名称首字符占位
export function AvatarWithFallback({ src, name }: AvatarWithFallbackProps) {
  const [failed, setFailed] = useState(false)
  const initial = name?.trim().charAt(0).toUpperCase() || "开"

  if (!src || !isValidAvatarUrl(src) || failed) {
    return (
      <svg viewBox="0 0 64 64" className="w-full h-full" role="img" aria-label={name || "开发者"}>
        <rect width="64" height="64" fill="#2563eb" />
        <text
          x="32"
          y="34"
          textAnchor="middle"
          dominantBaseline="central"
          fill="#ffffff"
          fontSize="28"
          fontWeight="500"
        >
          {initial}
        </text>
      </svg>
    )
  }

  return (
    <Image
      src={src}
      alt={name || "开发者"}
      width={64}
      height={64}
      className="w-full h-full object-cover"
      onError={() => setFailed(true)}
    />
  )
}
